angular.module('common').factory('QuestionGroupPreview', ['resourceFactory', function(resourceFactory) {
  return resourceFactory('/api/question_group_previews', {});
}]);
